import { render, staticRenderFns } from "./TopComponent.vue?vue&type=template&id=5476d3bc&scoped=true&"
import script from "./TopComponent.vue?vue&type=script&lang=js&"
export * from "./TopComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopComponent.vue?vue&type=style&index=0&id=5476d3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476d3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5476d3bc')) {
      api.createRecord('5476d3bc', component.options)
    } else {
      api.reload('5476d3bc', component.options)
    }
    module.hot.accept("./TopComponent.vue?vue&type=template&id=5476d3bc&scoped=true&", function () {
      api.rerender('5476d3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referralPage/partials/TopComponent.vue"
export default component.exports